import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import { getFleetDrivers } from '../../../services/fleetService';
import { apiParamsState } from '../../../storage/app';
import {
  fleetDriversFiltersState,
  fleetDriversHasAnyFilterState,
  fleetDriversReloadListState,
} from '../../../storage/fleetDrivers';

export function useFleetDrivers() {
  const apiParams = useRecoilValue(apiParamsState);
  const [filters, setFilters] = useRecoilState(fleetDriversFiltersState);
  const [reload, setReload] = useRecoilState(fleetDriversReloadListState);
  const resetAllFilters = useResetRecoilState(fleetDriversFiltersState);
  const hasActiveFilters = useRecoilValue(fleetDriversHasAnyFilterState);

  const resetFilters = () => {
    setFilters((prev) => ({
      ...prev,
      status: undefined,
    }));
  };

  const onReload = () => {
    setReload((prev) => !prev);
  };

  const onChangeFilter = (filterName: keyof typeof filters, value: any) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: value,
    }));
  };

  const loadFleetDrivers = async () => {
    if (!apiParams)
      return {
        drivers: undefined,
        error: 'Selecciona un espacio de trabajo.',
        total: undefined,
      };
    const { drivers, error, total } = await getFleetDrivers({
      page: filters.page,
      clientId: apiParams.clientId,
      subClientId: apiParams.subClientId,
      status: filters.status,
      search: filters.search,
    });
    return {
      drivers,
      error,
      total,
    };
  };

  return {
    hasActiveFilters,
    loadFleetDrivers,
    onReload,
    reload,
    resetAllFilters,
    resetFilters,
    page: filters.page,
    onChangePage: (page: number) => {
      onChangeFilter('page', page);
    },
    search: filters.search,
    onChangeSearch: (search: string) => {
      onChangeFilter('search', search);
    },
    filters: {
      status: filters.status,
    },
    onChangeFilter: (filterName: 'status', value: any) => {
      onChangeFilter(filterName, value);
    },
  };
}
